import locationActive from "assets/icons/location-active.png";
import type { LaboratoryMapProps } from "./types";
import { useEffect, useState } from "react";

export const useLaboratoryMap = ({ setAddress, map }: LaboratoryMapProps) => {
  const [currentMarker, setCurrentMarker] = useState<google.maps.Marker | null>(
    null
  );

  const [placeId, setPlaceId] = useState<string | null>(null);

  useEffect(() => {
    const activeIcon = {
      url: locationActive,
      scaledSize: new google.maps.Size(50, 50),
    };

    if (map) {
      const listener = map.addListener("click", function (event: any) {
        const geocoder = new google.maps.Geocoder();
        const geocoderRequest = {
          location: event.latLng,
          language: "ka",
        };
        geocoder.geocode(geocoderRequest, (results, status) => {
          if (status === "OK" && results?.[0]?.place_id !== placeId) {
            if (currentMarker) {
              currentMarker.setMap(null);
            }

            if (results?.[0]) {
              setAddress("address", results[0].formatted_address);
              setPlaceId(results[0].place_id);
              const marker = new window.google.maps.Marker({
                position: event.latLng,
                map: map,
                icon: activeIcon,
              });
              if (currentMarker) {
                currentMarker.setMap(null);
                setCurrentMarker(marker);
              } else {
                setCurrentMarker(marker);
              }
            } else {
              setPlaceId(null);
              console.log("No results found");
            }
          } else {
            setPlaceId(null);
            console.log("Geocoder failed due to: " + status);
          }
        });
      });

      return () => {
        google.maps.event.removeListener(listener);
      };
    }
  }, [currentMarker, map, setAddress]);

  const handleAddressInput = (addressInputValue: string) => {
    if (!addressInputValue?.trim()) {
      currentMarker && currentMarker.setMap(null);
      setPlaceId(null);
      setCurrentMarker(null);
      return;
    }

    if (map) {
      const activeIcon = {
        url: locationActive,
        scaledSize: new google.maps.Size(50, 50),
      };

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: addressInputValue }, (results, status) => {
        if (status === "OK") {
          if (results?.[0]?.place_id !== placeId && results?.[0]) {
            currentMarker && currentMarker.setMap(null);
            setPlaceId(results[0].place_id);

            const marker = new window.google.maps.Marker({
              position: results[0].geometry.location,
              icon: activeIcon,
              map: map,
            });

            if (currentMarker) {
              currentMarker.setMap(null);
              setCurrentMarker(marker);
            } else {
              setCurrentMarker(marker);
            }
          }
        } else {
          console.log("Geocoder failed due to: " + status);
          currentMarker && currentMarker.setMap(null);
          setPlaceId(null);
          setCurrentMarker(null);
        }
      });
    }
  };

  return { handleAddressInput };
};
